import React from 'react'
import './styles.scss'

interface Props {
  d: string
  color: string
  className?: string
}

export const Curve = ({ d, color ,className=""}: Props) => {
  return <path d={d} stroke={color} className={'curve '+className} />
}
